import { useState, type FormEvent } from 'react';

import { ErroDaApi } from '../api/cliente.ts';
import { useSessao } from '../autenticacao/sessao.tsx';
import { EntradaDeSenha } from '../componentes/Campo.tsx';

/** Entrada individual: cada usuária tem a própria conta e a própria sessão. */
export function PaginaEntrar(): React.JSX.Element {
  const { entrar } = useSessao();
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  async function aoEnviar(evento: FormEvent): Promise<void> {
    evento.preventDefault();
    setErro(null);
    setEnviando(true);

    try {
      await entrar(email, senha);
    } catch (causa) {
      setErro(
        causa instanceof ErroDaApi ? causa.message : 'Não foi possível entrar. Tente novamente.',
      );
    } finally {
      setEnviando(false);
    }
  }

  return (
    <main className="flex min-h-full items-center justify-center bg-marinho p-6">
      <form
        onSubmit={aoEnviar}
        className="w-full max-w-sm rounded-xl bg-superficie p-8 shadow-lg"
        noValidate
      >
        <p className="text-xs font-semibold uppercase tracking-widest text-dourado">Reducee</p>
        <h1 className="mt-1 text-2xl font-semibold text-marinho">Entrar</h1>
        <p className="mt-1 text-texto-suave">Sales + Flow</p>

        <label className="mt-6 block text-sm font-medium" htmlFor="campo-email">
          E-mail
        </label>
        <input
          id="campo-email"
          type="email"
          autoComplete="username"
          required
          value={email}
          onChange={(evento) => setEmail(evento.target.value)}
          className="mt-1 w-full rounded-lg border border-linha px-3 py-2 outline-none focus:border-marinho-claro"
        />

        <label className="mt-4 block text-sm font-medium" htmlFor="campo-senha">
          Senha
        </label>
        <div className="mt-1">
          <EntradaDeSenha
            id="campo-senha"
            autoComplete="current-password"
            required
            value={senha}
            onChange={(evento) => setSenha(evento.target.value)}
            className="w-full rounded-lg border border-linha px-3 py-2 outline-none focus:border-marinho-claro"
          />
        </div>

        {erro ? (
          <p role="alert" className="mt-4 rounded-lg bg-erro/10 px-3 py-2 text-sm text-erro">
            {erro}
          </p>
        ) : null}

        <button
          type="submit"
          disabled={enviando}
          className="mt-6 w-full rounded-lg bg-marinho px-4 py-2.5 font-medium text-white transition hover:bg-marinho-claro disabled:opacity-60"
        >
          {enviando ? 'Entrando…' : 'Entrar'}
        </button>
      </form>
    </main>
  );
}
